// extracted by mini-css-extract-plugin
export default {"input":"Control_input__Bg1Kl","sm":"Control_sm__4FjTi","std":"Control_std__FUy4F","lg":"Control_lg__L6G14","ns":"Control_ns__qRrgg","inValidate":"Control_inValidate__brzxI"};